import {ItemQuantityInfo} from '@wix/auto_sdk_ecom_cart-v-2';

export class QuantityInfoModel {
  public quantity: number;
  public fixedQuantity: boolean;

  constructor(params: QuantityInfoModel) {
    this.quantity = params.quantity;
    this.fixedQuantity = params.fixedQuantity;
  }

  public static fromCheckoutV1(
    confirmedQuantity: number,
    fixedQuantity?: boolean | null,
    hideQuantity?: boolean | null
  ) {
    return new QuantityInfoModel({
      quantity: confirmedQuantity,
      fixedQuantity: (hideQuantity || fixedQuantity) ?? false,
    });
  }

  public static fromCartV2(quantityInfo: ItemQuantityInfo): QuantityInfoModel {
    return new QuantityInfoModel({
      quantity: quantityInfo.confirmedQuantity!,
      fixedQuantity: quantityInfo.fixedQuantity ?? /* istanbul ignore next */ false,
    });
  }
}
